<template>
  <div>
    <Form
      page-title="Edit Menu"
      buttonName="Update"
      :businessId="businessId"
      :branchId="branchId"
      :isInList="isInList"
      :model="model"
      @submit="submit"
      :loading="loading"
    />
  </div>
</template>
<script>
import { submitAndNotify } from "@/helpers/utils";
import Form from "./Form";
import { updateOrder } from "@/API/OrdersAPIs";
export default {
  name: "Edit",
  components: { Form },
  props: ["isInList", "model", "businessId", "showAdd", "branchId"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    submit(formData) {
      formData.branchId = this.branchId;
      formData.businessId = this.businessId;

      const callback = () => {
        this.$emit("onSubmit");
        this.$emit("showAddChanged", !this.showAdd);
      };
      submitAndNotify(this, updateOrder(formData), callback);
    }
  }
};
</script>
<style></style>
